/**
 * Scroll Up Button Functionality
 * Shows/hides button based on scroll position and handles smooth scroll to top
 */
class ScrollUpButton {
  constructor() {
    this.button = document.querySelector(".scroll_up-btn");
    this.scrollThreshold = 300; // Show button after scrolling 300px

    if (!this.button) {
      return;
    }

    this.init();
  }

  init() {
    if (!this.button) {
      return;
    }

    // Check initial scroll position
    this.handleScroll();

    // Add scroll event listener with throttling
    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Add click event listener for smooth scroll
    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      this.scrollToTop();
    });
  }

  handleScroll() {
    if (!this.button) {
      return;
    }

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollPosition > this.scrollThreshold) {
      this.button.classList.add("is-visible");
    } else {
      this.button.classList.remove("is-visible");
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ScrollUpButton();
  });
} else {
  new ScrollUpButton();
}
